import React from 'react';

const TitleBadge = ({ titled, chessTitle, size = 'default' }) => {
  if (!titled || !chessTitle) return null;
  const sizeClasses = size === 'sm'
    ? 'px-1 py-px text-[9px] mr-1 rounded-sm'
    : 'px-1.5 py-0.5 text-xs mr-2 rounded';
  return (
    <span className={`inline-flex items-center bg-red-600 text-white font-bold align-middle ${sizeClasses}`}>
      {chessTitle}
    </span>
  );
};

export default TitleBadge;
